import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */
export var StringUtils = /*#__PURE__*/function () {
  function StringUtils(value) {
    _classCallCheck(this, StringUtils);

    this._value = !!value ? String(value) : "";
  }

  _createClass(StringUtils, [{
    key: "padLeft",
    value: function padLeft(length, _char) {
      while (this._value.length < (length || 1)) {
        this._value = _char + this._value;
      }

      return new StringUtils(this._value);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._value;
    }
  }], [{
    key: "replaceStringTokens",
    value: function replaceStringTokens(str) {
      if (str != null) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        args.forEach(function (arg) {
          var regex = new RegExp("\\{".concat(Object.keys(arg)[0], "\\}"), "gi");
          str = str.replace(regex, Object.values(arg)[0]);
        });
      }

      return str;
    }
  }]);

  return StringUtils;
}();